import React from 'react';

const ProductNutrition = ({ productNutrition, setProductNutrition }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductNutrition((prev) => ({ 
      ...prev, 
      [name]: value 
    }));
  };

  return (
    <div className="product-nutrition">
      <h6 className=' mb-2'>المعلومات الغذائية</h6>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label">السعرات الحرارية</label>
            <input
              type="number"
              name="calories"
              value={productNutrition?.calories ??""}
              onChange={handleChange}
              className="form-control"
              placeholder="السعرات الحرارية"
              min="0"
            />
            <small className="text-muted">سعرة حرارية</small>
          </div>
        </div>
        
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label">البروتين</label>
            <input
              type="number"
              name="protein"
              value={productNutrition?.protein  ??""}
              onChange={handleChange}
              className="form-control"
              placeholder="البروتين"
              step="0.1"
              min="0"
            />
            <small className="text-muted">جرام</small>
          </div>
        </div>
        
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label">الدهون</label>
            <input
              type="number"
              name="fat"
              value={productNutrition?.fat  ??""}
              onChange={handleChange}
              className="form-control"
              placeholder="الدهون"
              step="0.1"
              min="0"
            />
            <small className="text-muted">جرام</small>
          </div>
        </div>
        
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label">الكربوهيدرات</label>
            <input
              type="number"
              name="carbohydrates"
              value={productNutrition?.carbohydrates  ??""}
              onChange={handleChange}
              className="form-control"
              placeholder="الكربوهيدرات"
              step="0.1"
              min="0"
            />
            <small className="text-muted">جرام</small>
          </div>
        </div>
        
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label">السكر</label>
            <input
              type="number"
              name="sugar"
              value={productNutrition?.sugar  ??""}
              onChange={handleChange}
              className="form-control"
              placeholder="السكر"
              step="0.1"
              min="0"
            />
            <small className="text-muted">جرام</small>
          </div>
        </div>
        
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label">الألياف</label>
            <input
              type="number"
              name="fiber"
              value={productNutrition?.fiber  ??""}
              onChange={handleChange}
              className="form-control"
              placeholder="الألياف"
              step="0.1"
              min="0"
            />
            <small className="text-muted">جرام</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductNutrition;